/*
 * @Descripttion: 路由鉴权
 * @FilePath: /mall-wap-vue/src/permission.js
 * @Author: 张兴业
 * @Date: 2020-09-27 14:04:08
 * @LastEditors: hl
 * @LastEditTime: 2026-07-09 14:28:46
 */
import Vue from "vue";
import router from "./router";
import { isLogin, setToken, setCurrentRole } from "@/utils/authority";

const routerStack = [];
Vue.prototype.$routerStack = routerStack;

router.beforeEach(async (to, from, next) => {
  // 如果检测到 URL Query 传参带有 token，进行登录态同步
  if (to.query.token) {
    const token = to.query.token;
    setToken({ access_token: token });

    // 🔑 核心同步：立刻将本地角色缓存更新为注册用户，防止 App.vue 因异步接口时间差误判为游客而重新拉取 GuestToken
    setCurrentRole("Customer");

    // 剔除 URL 中的 token 参数，保留其它参数（如 orderSn, isMiniProgram 等），保护 Token 安全
    const query = { ...to.query };
    delete query.token;

    // 用干净的 URL 重新导航进入
    return next({
      path: to.path,
      query,
      replace: true
    });
  }

  // 维护全局简易路由历史栈，记录页面路径
  if (routerStack.length === 0 && from.path && from.path !== "/") {
    routerStack.push(from.path);
  }
  const path = to.path;
  const index = routerStack.indexOf(path);
  if (index !== -1) {
    // 后退：截断目标页之后的记录
    routerStack.splice(index + 1);
  } else {
    // 前进：压入新页面
    routerStack.push(path);
  }

  if (isLogin()) {
    if (to.path === "/login") {
      // 如果已经登录了，前往首页
      next({
        path: "/",
        query: {
          ...to.query,
          slug: to.query.slug || ""
        }
      });
    } else {
      if (to.query.slug) {
        return next();
      }
      if (from.query.slug) {
        const query = {
          ...to.query,
          slug: from.query.slug
        };
        router.push({
          path: to.path,
          query
        });
        return;
      } else return next();
    }
  } else {
    if (
      to.path === "/login" ||
      to.path === "/binding" ||
      to.path === "/forgot" ||
      to.path === "/forgot/reset" ||
      to.path === "/agreement/login1" ||
      to.path === "/agreement/login2" ||
      to.path === "/mine/question/list" ||
      to.path === "/mine/question/detail" ||
      to.path === "/order/explaintime" ||
      to.path === "/order/milkexplaintime" ||
      to.path === "/banner/link" ||
      to.path === "/poster/sm" ||
      to.path === "/poster/ad-machine" ||
      to.path === "/agreement" ||
      to.path === "/order/orderpay" ||
      to.path === "/user/order/fast/qqgpay" ||
      to.path === "/product/detail"
    ) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          ...to.query,
          redirect: to.path,
          slug: to.query.slug || ""
        }
      });
    }
  }
});
